import { toast } from '@/hooks/use-toast';
import { forceSignOut, isFatalAuthError } from './forceSignOut';

/**
 * Detects expired/invalid session errors and triggers a hard sign-out.
 * Call this in mutation/query error handlers.
 *
 * IMPORTANT: This must be precise to avoid false-positive logouts.
 * Edge function errors (403 geofence rejection, 400 validation, etc.)
 * must NOT trigger a logout.
 */
export function handleSessionError(error: any): boolean {
  // Edge function non-2xx wrapper: only act if it's actually a 401
  const msg = typeof error?.message === 'string' ? error.message : '';
  const httpStatus = error?.status ?? error?.context?.status ?? null;
  const isEdgeFunctionError = msg.includes('Edge Function returned a non-2xx status code');
  if (isEdgeFunctionError && httpStatus !== 401) {
    return false;
  }

  if (!isFatalAuthError(error)) {
    return false;
  }

  toast({
    title: 'Din session er udløbet',
    description: 'Log venligst ind igen for at fortsætte.',
    variant: 'destructive',
    duration: 5000,
  });

  // Small delay so the user sees the toast before redirect
  setTimeout(() => {
    void forceSignOut('session_expired');
  }, 800);

  return true;
}
